'use client'

import { VideoDialog } from 'components/VideoDialog'

export function VideoDialogV2({ content }) {
  return <VideoDialog content={content} />
}
